import { parseU64OrZero } from "@bridgesplit/utils";

import { LockboxAccessResponseApi, LockboxAssetDecodedApi, LockboxDetailApi, LockboxSummaryApi } from "../api/lockbox";
import { LockboxAccessResponse, LockboxAssetDecoded, LockboxDetail, LockboxSummary } from "../domain/lockbox";

export function parseLockboxAssetFromApi(api: LockboxAssetDecodedApi): LockboxAssetDecoded {
    switch (api.kind) {
        case "token":
            return {
                kind: "token",
                mint: api.mint,
                decimals: api.decimals,
                amount: parseU64OrZero(api.amount),
                lastUpdateTime: api.lastUpdateTime
            };
        case "unsupported":
            return {
                kind: "unsupported",
                identifierHex: api.identifierHex,
                amount: parseU64OrZero(api.amount),
                lastUpdateTime: api.lastUpdateTime
            };
    }
}

export function parseLockboxSummaryFromApi(api: LockboxSummaryApi): LockboxSummary {
    return {
        address: api.address,
        nonce: api.nonce,
        nftMint: api.nftMint,
        state: api.state,
        initializationTime: api.initializationTime,
        assetCount: api.assetCount
    };
}

export function parseLockboxSummaryListFromApi(api: LockboxSummaryApi[]): LockboxSummary[] {
    return api.map(parseLockboxSummaryFromApi);
}

export function parseLockboxDetailFromApi(api: LockboxDetailApi): LockboxDetail {
    return {
        address: api.address,
        nonce: api.nonce,
        nftMint: api.nftMint,
        state: api.state,
        initializationTime: api.initializationTime,
        assets: api.assets.map(parseLockboxAssetFromApi)
    };
}

export function parseLockboxAccessFromApi(api: LockboxAccessResponseApi): LockboxAccessResponse {
    return { allowed: api.allowed };
}
